import React, { useEffect, useState } from "react";
// import ComingSoon from "../components/comingSoon";
import Layout, { Container } from "../components/layout";
import { useNavigate } from "react-router-dom";
import { useUser } from "../config/userProvider";
import axios from "axios";
import { apiurl } from "../config/config";

const Support = () => {
  const { userData } = useUser();
  const [loader, setLoader] = useState(false);
  const [reportData, setReportData] = useState({});
  const [tickets, setTickets] = useState([]);

  console.log("loader", loader);

  const options = [
    {
      title: "Create Ticket",
      description: "Submit a new support ticket to get help.",
      icon: "🎟️",
      url: "/support/tickets/create",
    },
    {
      title: "My Tickets",
      description: "View and manage your existing support tickets.",
      icon: "📂",
      url: "/support/tickets",
    },
    {
      title: "Contact",
      description: "Reach out to our team for further assistance.",
      icon: "📞",
      url: "https://fixlabs.ai/contact",
      target:"_blank" 
    },
    {
      title: "Help Center",
      description: "Access articles and FAQs for self-service support.",
      icon: "📖",
      url: "https://fixlabs.ai/help-center",
      target:"_blank" 
    },
    {
      title: "Developer Center",
      description: "Find APIs, documentation, and developer tools.",
      icon: "💻",
      url: "https://developer.fixall.ai/",
      target:"_blank" 
    },
    {
      title: "Live Chat",
      description: "Get instant support with our live chat feature.",
      icon: "💬",
      url: "/chat",
    },
  ];


  useEffect(() => {
    setLoader(true);
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${apiurl}/admin/v1/ticket/report`,
      headers: {
        "Content-Type": "application/json",
        // Authorization: token,
      },
    };

    axios
      .request(config)
      .then((response) => {
        if (response.data.success === true) {
          setReportData(response.data.data);
        }
        setLoader(false);
      })
      .catch((error) => {
        console.log(error);
        setLoader(false);
      });
  }, []);


  useEffect(() => {
    setLoader(true);
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${apiurl}/admin/v1/ticket/get`,
      headers: {
        "Content-Type": "application/json",
        // Authorization: token,
      },
    };

    axios
      .request(config)
      .then((response) => {
        if (response.data.success === true) {
          setTickets(response.data.data);
        }
        setLoader(false);
      })
      .catch((error) => {
        console.log(error);
        setLoader(false);
      });
  }, []);

  console.log("reportData",reportData)
  console.log("tickets",tickets)
  const [priorityFilter, setPriorityFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const navigate = useNavigate();

  // Filter tickets based on selected filters
  const filteredTickets = tickets?.filter((ticket) => {
    const matchesPriority = priorityFilter
      ? ticket?.priority === priorityFilter
      : true;
    const matchesStatus = statusFilter ? ticket?.status === statusFilter : true;
    return matchesPriority && matchesStatus;
  });
  return (
    <Layout>
      <Container overflow={"overflow-scroll"}>
        {userData?.userType && userData?.userType === "master" ? (
          <div>
      {/* Dashboard Header Section */}
      <section className="py-4 rounded-lg sm:py-4 lg:py-4 bg-teal-400">
        <div className="px-4 mx-auto max-w-9xl sm:px-6 lg:px-8">
          <h2 className="text-2xl font-bold text-white text-center">
            Support Dashboard
          </h2>
          <div className="grid grid-cols-1 gap-2 gap-x-0.5 px-4 mt-8 sm:px-0 lg:mt-16 sm:grid-cols-2 lg:grid-cols-5 xl:gap-x-4">
            {/* Dashboard Cards */}
            {["Pending", "Resolved", "Open", "Close", "Hold"].map((status) => (
              <div
                key={status}
                className="overflow-hidden bg-white px-2 shadow-md rounded-lg"
              >
                <div className="p-2">
                  <div className="flex items-center justify-between">
                    <div className="px-0 text-sm font-bold">{`Ticket ${status}`}</div>
                    <div className="px-0 text-sm font-bold text-emerald-400">
                      {reportData?.[status]?.total || 0}
                    </div>
                  </div>
                  <div className="px-4 py-4 mt-6 flex items-center justify-center">
                    <h4
                      className={`mt-1.5 text-6xl font-medium leading-tight text-${
                        status === "Pending"
                          ? "yellow-300"
                          : status === "Resolved"
                          ? "green-500"
                          : status === "Open"
                          ? "orange-500"
                          : status === "Close"
                          ? "blue-500"
                          : "purple-500"
                      }`}
                    >
                      {reportData?.[status]?.today || 0}
                    </h4>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Filters and View All Button */}
      <section className="py-4 px-8 bg-white shadow-xl">
        <div className="flex justify-between items-center">
          <div className="flex gap-4">
            {/* Priority Filter */}
            <select
              value={priorityFilter}
              onChange={(e) => setPriorityFilter(e.target.value)}
              className="border rounded-md px-4 py-2"
            >
              <option value="">All Priorities</option>
              <option value="High">High</option>
              <option value="Medium">Medium</option>
              <option value="Low">Low</option>
            </select>

            {/* Status Filter */}
            <select
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              className="border rounded-md px-4 py-2"
            >
              <option value="">All Statuses</option>
              <option value="Pending">Pending</option>
              <option value="Resolved">Resolved</option>
              <option value="Open">Open</option>
              <option value="Closed">Closed</option>
              <option value="On Hold">On Hold</option>
            </select>
          </div>

          {/* View All Button */}
          <button
            onClick={() => navigate("/support/ticketslist")}
            className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600"
          >
            View All
          </button>
        </div>
      </section>

      {/* Tickets Table */}
      <section className="py-4 px-8 bg-white">
        <div className="relative overflow-x-auto shadow-md border rounded-lg">
          <table className="w-full text-sm text-left">
            <thead className="text-xs text-gray-700 uppercase bg-gray-100">
              <tr>
                <th scope="col" className="px-6 py-3">
                  Ticket#
                </th>
                <th scope="col" className="px-6 py-3">
                  Status
                </th>
                <th scope="col" className="px-6 py-3">
                  Date Created
                </th>
                <th scope="col" className="px-6 py-3">
                  Name
                </th>
                <th scope="col" className="px-6 py-3">
                  Issue Related To
                </th>
                <th scope="col" className="px-6 py-3">
                  View Ticket
                </th>
              </tr>
            </thead>
            <tbody>
              {filteredTickets?.length > 0 ? (
                filteredTickets.map((ticket) => (
                  <tr
                    key={ticket.id}
                    className="bg-white border-b hover:bg-gray-50"
                  >
                    <td className="px-6 py-4 font-medium text-gray-900">
                      {ticket.id}
                    </td>
                    <td className={`px-6 py-4 text-${
                        ticket?.status === "Pending"
                          ? "yellow-300"
                          : ticket?.status === "Resolved"
                          ? "green-500"
                          : ticket?.status === "Open"
                          ? "orange-500"
                          : ticket?.status === "Close"
                          ? "blue-500"
                          : "purple-500"
                      }`}>{ticket.status}</td>
                    <td className="px-6 py-4">{ticket.createdAt}</td>
                    <td className="px-6 py-4">
                      {ticket.firstname} {ticket.lastname}
                    </td>
                    <td className="px-6 py-4">{ticket.category}</td>
                    <td className="px-6 py-4">
                      <button
                        onClick={() => navigate(`/support/ticketslist/${ticket?._id}/manage`)}
                        className="font-medium text-blue-600 hover:underline"
                      >
                        View Ticket
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="6"
                    className="text-center py-4 text-gray-500 font-medium"
                  >
                    No tickets found for the selected filters.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </section>
    </div>
        ) : (
          <>
            <div className="min-h-screen bg-gray-50 py-10 px-4">
              <div className="text-center mb-10">
                <h1 className="text-3xl font-semibold md:font-bold text-gray-800">
                  We’re here to help
                </h1>
              </div>

              {/* Search Bar */}
              <div className="max-w-xl mx-auto mb-10">
                <div className="relative">
                  <input
                    type="text"
                    placeholder="Search"
                    className="w-full border border-gray-300 rounded-lg py-3 px-4 focus:ring-2 focus:ring-blue-500 focus:outline-none"
                  />
                  <button className="absolute top-1/2 right-3 transform -translate-y-1/2 text-gray-400">
                    🔍 {/* Replace with a search icon */}
                  </button>
                </div>
              </div>

              {/* Grid Layout */}
              <div className="max-w-[100%] mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {options.map((option, index) => (
                  <a
                  href={option?.url}
                    // to={option?.url}
                    target={option?.target}
                    key={index}
                    className="bg-white p-6 rounded-lg shadow hover:shadow-lg transition"
                  >
                    {/* Icon */}
                    <div className="text-blue-500 text-4xl mb-4">
                      {option.icon}
                    </div>
                    {/* Title */}
                    <h3 className="text-xl font-semibold text-gray-800 mb-2">
                      {option.title}
                    </h3>
                    {/* Description */}
                    <p className="text-gray-600">{option.description}</p>
                  </a>
                ))}
              </div>
            </div>
          </>
        )}
      </Container>
    </Layout>
  );
};

export default Support;
